export class Surgery {
  surgeryId: number;
  name: string;
  description: string;
  patientProvided: boolean;
}